
export const licitaciones_item = [
    {
        "licitaciones_item_nombre" : "Publicación de Licitaciones",
        "licitaciones_item_url" : "https://siom.hidalgo.gob.mx/LICITACIONES/VISTAS/WebFrmLC004.aspx",
        "licitaciones_item_descripcion":"Consulta las Convocatorias de Licitaciones."
    },
    {
        "licitaciones_item_nombre" : "Servicio de Licitaciones Públicas",
        "licitaciones_item_url" : "https://ruts.hidalgo.gob.mx/ver/5805",
        "licitaciones_item_descripcion":"Conoce la información acerca del servicio de Licitaciones Públicas."
    }
]
